import { defineMessages } from 'react-intl';

export const messages: {
	premiumEdition: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	whiteboardsUnlimited: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	premiumEdition: {
		id: 'recommend-standard-over-premium.premium-edition-column.premium-edition',
		description: 'Label for Premium edition plan',
		defaultMessage: 'Premium',
	},
	whiteboardsUnlimited: {
		id: 'recommend-standard-over-premium.premium-edition-column.whiteboards-unlimited',
		description: 'Label indicating whiteboards feature is unlimited in Premium edition',
		defaultMessage: 'Unlmtd',
	},
});
